import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type ImportExcelProps, useImportFinanceTablesModal } from './ImportFinanceTablesModal';

const ImportExcel = (props: ImportExcelProps) => {
    const { t } = useTranslation(['financeProductDetails']);
    const importModal = useImportFinanceTablesModal();

    return (
        <>
            <Button key="import" onClick={importModal.open} size="middle" type="primary">
                {t('financeProductDetails:actions.importExcel')}
            </Button>
            {importModal.render(props)}
        </>
    );
};

export default ImportExcel;
